import { useState } from "react";
import { Download, Plus, Loader2 } from "lucide-react";
import { toast } from "sonner";

import { Button } from "@/components/ui/button";
import ClassFilterPills from "./ClassFilterPills";

// FIN-4 — Toolbar.
// Linha responsiva: pills à esquerda, ações (Exportar + Novo) à direita.
// Contador "{visible} de {total}" aparece quando filtro de classe ativo.

export default function InvestimentosToolbar({
  classFilter,
  onChangeClass,
  exportCsv,
  onCreate,
  visibleCount,
  totalCount,
}) {
  const [exporting, setExporting] = useState(false);

  const handleExport = async () => {
    if (exporting) return;
    setExporting(true);
    try {
      const out = await exportCsv();
      toast.success(`Exportado: ${out.filename}`);
    } catch (e) {
      toast.error(e.message || "Falha ao exportar investimentos");
    } finally {
      setExporting(false);
    }
  };

  const filterActive = classFilter && classFilter !== "Todos";

  return (
    <div
      className="flex flex-col md:flex-row md:items-center md:justify-between gap-3"
      data-testid="invest-toolbar"
    >
      <div className="flex items-center gap-3 flex-wrap">
        <ClassFilterPills value={classFilter} onChange={onChangeClass} />
        {filterActive && Number.isFinite(totalCount) && (
          <span
            className="text-micro text-foreground-muted whitespace-nowrap"
            aria-live="polite"
            data-testid="invest-filter-count"
          >
            {visibleCount} de {totalCount} ativo{totalCount === 1 ? "" : "s"}
          </span>
        )}
      </div>

      <div className="flex items-center gap-2 self-end md:self-auto">
        <Button
          variant="ghost"
          size="md"
          onClick={handleExport}
          disabled={exporting}
          data-testid="invest-export-btn"
        >
          {exporting ? (
            <Loader2 className="w-4 h-4 animate-spin" aria-hidden="true" />
          ) : (
            <Download className="w-4 h-4" aria-hidden="true" />
          )}
          <span className="hidden md:inline">Exportar</span>
        </Button>
        <Button
          variant="primary"
          size="md"
          onClick={onCreate}
          data-testid="invest-create-btn"
        >
          <Plus className="w-4 h-4" aria-hidden="true" />
          Novo investimento
        </Button>
      </div>
    </div>
  );
}
